<template>
 
<footer class="footer">
        <p class="copyright">微科斯公司控制台 © 2025-2026 深圳市微科斯科技有限公司</p>
      </footer>
</template>

<script setup>
import { useRouter } from 'vue-router'
import UserInfo from '@/components/comm/UserInfo.vue'
import { ref } from 'vue'

const props = defineProps({
   
  modelValue: {
    type: String,
    default: '首页'
  },
  userName: {
    type: String,
    default: 'admin'
  }
})
const navItems = ref([
  { 
    name: '首页', 
    icon: '🏠', 
    link: '/',
    route: { name: 'Home' },
    target: '_self'
  },
  { 
    name: '商品管理', 
    icon: '📦', 
    link: '/Console',
    route: { name: 'Console' },
    target: '_self'
  } ,
  { 
    name: '订单管理', 
    icon: '🛒', 
    link: '/OrderList',
    route: { name: 'OrderList' },
    target: '_self'
  }, 
  { 
    name: '个人中心', 
    icon: '👤', 
     link: '/Account',
    route: { name: 'Account' },
    target: '_self'
  }, 
  { 
    name: '官网首页', 
    icon: '🌐', 
    link: 'https://help.weikesi.com',
    target: '_blank'  // 在新标签页打开
  }  
])


const emit = defineEmits(['update:modelValue', 'navigate'])
const router = useRouter()

const handleClick = (event, item) => {
  // 阻止默认跳转，使用路由跳转
  event.preventDefault()
  
  // 更新当前选中状态
  emit('update:modelValue', item.name)
  emit('navigate', item)
  
  // 使用 Vue Router 进行跳转
  if (item.route) {
    router.push(item.route)
  } else if (item.link) {
    // 外部链接或普通链接
    if (item.link.startsWith('http')) {
      window.open(item.link, item.target || '_self')
    } else {
      router.push(item.link)
    }
  }
}
</script>

<style scoped>

 /* 页脚 */
.footer {
  margin-top: 30px;
  text-align: center;
}

.copyright {
  color: #6f8db0;
  font-size: 0.8rem;
}
</style>